export enum BillingInfoPlan {
  APPSUMO_SUBSCRIPTION = 'appsumo-subscription',
  APPSUMO_SUBSCRIPTION_2023 = 'appsumo-subscription-2023',
  BUSINESS_MONTHLY = 'business-monthly',
  BUSINESS_YEARLY = 'business-yearly',
  BUSINESS2023_MONTHLY = 'business2023-monthly',
  BUSINESS2023_YEARLY = 'business2023-yearly',
  INHERITED_PRO = 'inherited-pro',
  MONTHLY_PRO = 'monthly-pro',
  NIMBUS_YEARLY_PRO = 'nimbus-yearly-pro',
  PLUS_MONTHLY = 'plus-monthly',
  PLUS_YEARLY = 'plus-yearly',
  TEAM_MONTHLY = 'team-monthly',
  TEAM_YEARLY = 'team-yearly',
  PLUS2024_MONTHLY = 'plus2024-monthly',
  PLUS2024_YEARLY = 'plus2024-yearly',
  TEAM2024_MONTHLY = 'team2024-monthly',
  TEAM2024_YEARLY = 'team2024-yearly',
  BUSINESS2024_MONTHLY = 'business2024-monthly',
  BUSINESS2024_YEARLY = 'business2024-yearly',
  TRIAL = 'trial',
  NOPE = '',
}

export interface BillingInfo {
  orgId: string;
  subscriptionId: string;
  plan: BillingInfoPlan;
  createdAt: number;
  updatedAt: number;
  members: number;
  active: boolean;
  inheritedFromOrgs: string[];
  membersIncludingOwner: boolean;
  trialEndsAt: number;
}
